import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/lib/site";

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="editorial-marquee"
      aria-label="Editorial marquee"
      className="relative border-y border-[#ebebeb] bg-[#f7f7f7] py-4 overflow-hidden"
    >
      <Marquee gradient={false} speed={25} pauseOnHover={false} autoFill>
        {MARQUEE_ITEMS.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="flex items-center gap-8 pr-8 text-[15px] font-medium tracking-tight text-[#222222]"
          >
            <span>{item}</span>
            <span
              className="inline-block h-1.5 w-1.5 rounded-full bg-[#a6a6a6]"
              aria-hidden
            />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
